import { render } from "./AlertSettings.vue?vue&type=template&id=3eb63068&scoped=true"
import script from "./AlertSettings.vue?vue&type=script&lang=js"
export * from "./AlertSettings.vue?vue&type=script&lang=js"

import "./AlertSettings.vue?vue&type=style&index=0&id=3eb63068&lang=scss&scoped=true"
import "./AlertSettings.vue?vue&type=style&index=1&id=3eb63068&lang=scss"
script.render = render
script.__scopeId = "data-v-3eb63068"

export default script